import { Flex, Text } from '@chakra-ui/react'
import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useModalState } from '~/atoms/ModalState'
import { useSettingsState } from '~/atoms/SettingsState'
import { useUserState } from '~/atoms/UserState'
import {
  MangoButton,
  MangoButtonVariant,
} from '~/components/shared/MangoButton'
import { MangoInput } from '~/components/shared/MangoInput'
import { MangoModal } from '~/components/shared/MangoModal'
import { formatPhoneNumber } from '~/utils/formatter'

import { useNewSpeedDialModalStyle } from './componentStyles/NewSpeedDialModal.style'

export const NewSpeedDialModal = () => {
  const { t } = useTranslation()
  const labelRef = useRef<HTMLInputElement>(null)
  const numberRef = useRef<HTMLInputElement>(null)

  const [labelText, setLabelText] = useState<string>('')
  const [numberText, setNumberText] = useState<string>('')
  const {
    speedDialModal: [speedDialModalState, setSpeedDialModalState],
  } = useModalState()
  const { pbxId } = useUserState()
  const { updateSpeedDial } = useSettingsState(pbxId)

  const handleLabelChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setLabelText(e.target.value)
  }

  const handleNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNumberText(formatPhoneNumber(e.target.value))
  }

  useEffect(() => {
    setLabelText(speedDialModalState.speedDial?.label || '')
    setNumberText(speedDialModalState.speedDial?.number || '')
  }, [speedDialModalState])

  const handleClose = () => {
    setSpeedDialModalState({ open: false })
    setLabelText('')
    setNumberText('')
  }
  const handleSave = () => {
    if (labelText && numberText) {
      updateSpeedDial(labelText, numberText, speedDialModalState.speedDial?.id)
      handleClose()
    }
    if (!labelText) {
      labelRef.current?.focus()
    }
    if (!numberText) {
      numberRef.current?.focus()
    }
  }

  const styles = useNewSpeedDialModalStyle()

  return (
    <MangoModal
      open={speedDialModalState.open}
      onOpenChange={(details) => {
        if (!details.open) handleClose()
      }}
      header={
        speedDialModalState.speedDial?.id
          ? t('newSpeedDialModal.editSpeedDial')
          : t('newSpeedDialModal.addSpeedDial')
      }
      body={
        <Flex css={styles.bodyContainer}>
          <Flex css={styles.inputContainer}>
            <Text css={styles.inputLabel}>
              {t('newSpeedDialModal.contactName')}
            </Text>
            <MangoInput
              ref={labelRef}
              variant="mango"
              placeholder={t('newSpeedDialModal.contactName')}
              value={labelText}
              onChange={handleLabelChange}
            />
          </Flex>
          <Flex css={styles.inputContainer}>
            <Text css={styles.inputLabel}>{t('newSpeedDialModal.number')}</Text>
            <MangoInput
              ref={numberRef}
              variant="mango"
              placeholder={t('newSpeedDialModal.number')}
              value={formatPhoneNumber(numberText)}
              onChange={handleNumberChange}
            />
          </Flex>
        </Flex>
      }
      footer={
        <Flex css={styles.footerContainer}>
          <MangoButton
            variant={MangoButtonVariant.Default_100}
            onClick={handleClose}
          >
            {t('newSpeedDialModal.cancelButton')}
          </MangoButton>
          <MangoButton
            variant={MangoButtonVariant.Default_300}
            onClick={handleSave}
          >
            {t('newSpeedDialModal.saveButton')}
          </MangoButton>
        </Flex>
      }
    ></MangoModal>
  )
}
